import React from 'react';
import { useWindowSize } from 'react-use';

const useSlidesMenuWidth = () => {
  const { width, height } = useWindowSize();
  const defaultWidth = 240;
  const calculatedWidth = React.useMemo(() => {
    if (width < 1220) {
      return Math.max(width * (defaultWidth / 1220), 120);
    }
    return defaultWidth;
  }, [width]);

  return calculatedWidth;
};

export default useSlidesMenuWidth;
